export const banks = [
  {
    bankCode: '004',
    bankName: '臺灣銀行',
  },
  {
    bankCode: '005',
    bankName: '台灣土地銀行',
  },
  {
    bankCode: '006',
    bankName: '合作金庫銀行',
  },
  {
    bankCode: '007',
    bankName: '第一商業銀行',
  },
  {
    bankCode: '008',
    bankName: '華南商業銀行',
  },
  {
    bankCode: '009',
    bankName: '彰化商業銀行',
  },
  {
    bankCode: '010',
    bankName: '花旗(台灣)(原華僑銀行)',
  },
  {
    bankCode: '011',
    bankName: '上海商業銀行',
  },
  {
    bankCode: '012',
    bankName: '台北富邦銀行',
  },
  {
    bankCode: '013',
    bankName: '國泰世華商業銀行',
  },
  {
    bankCode: '016',
    bankName: '高雄銀行',
  },
  {
    bankCode: '017',
    bankName: '兆豐國際商業銀行',
  },
  {
    bankCode: '021',
    bankName: '花旗銀行',
  },
  {
    bankCode: '024',
    bankName: '美國運通銀行',
  },
  {
    bankCode: '025',
    bankName: '首都銀行',
  },
  {
    bankCode: '039',
    bankName: '荷蘭銀行',
  },
  {
    bankCode: '040',
    bankName: '中華開發',
  },
  {
    bankCode: '050',
    bankName: '台灣中小企業銀行',
  },
  {
    bankCode: '052',
    bankName: '渣打國際商銀(原新竹商銀)',
  },
  {
    bankCode: '053',
    bankName: '台中商業銀行',
  },
  {
    bankCode: '054',
    bankName: '京城商銀',
  },
  {
    bankCode: '057',
    bankName: '台東區中小企業銀行',
  },
  {
    bankCode: '072',
    bankName: '德意志銀行',
  },
  {
    bankCode: '073',
    bankName: '東亞銀行',
  },
  {
    bankCode: '081',
    bankName: '匯豐銀行',
  },
  {
    bankCode: '101',
    bankName: '稻江商銀',
  },
  {
    bankCode: '102',
    bankName: '華泰商業銀行',
  },
  {
    bankCode: '103',
    bankName: '新光商業銀行',
  },
  {
    bankCode: '104',
    bankName: '台北市第五信用合作社',
  },
  {
    bankCode: '106',
    bankName: '台北市第九信用合作社',
  },
  {
    bankCode: '108',
    bankName: '陽信商業銀行',
  },
  {
    bankCode: '114',
    bankName: '基隆第一信用合作社',
  },
  {
    bankCode: '115',
    bankName: '基隆第二信用合作社',
  },
  {
    bankCode: '118',
    bankName: '板信商業銀行',
  },
  {
    bankCode: '119',
    bankName: '台北縣淡水第一信用合作社',
  },
  {
    bankCode: '120',
    bankName: '台北縣淡水信用合作社',
  },
  {
    bankCode: '124',
    bankName: '宜蘭信用合作社',
  },
  {
    bankCode: '127',
    bankName: '桃園信用合作社',
  },
  {
    bankCode: '130',
    bankName: '新竹第一信用合作社',
  },
  {
    bankCode: '132',
    bankName: '新竹第三信用合作社',
  },
  {
    bankCode: '139',
    bankName: '苗栗縣竹南信用合作社',
  },
  {
    bankCode: '146',
    bankName: '台中市第二信用合作社',
  },
  {
    bankCode: '147',
    bankName: '三信商業銀行',
  },
  {
    bankCode: '158',
    bankName: '彰化第一信用合作社',
  },
  {
    bankCode: '161',
    bankName: '彰化第五信用合作社',
  },
  {
    bankCode: '162',
    bankName: '彰化第六信用合作社',
  },
  {
    bankCode: '163',
    bankName: '彰化第十信用合作社',
  },
  {
    bankCode: '165',
    bankName: '彰化縣鹿港信用合作社',
  },
  {
    bankCode: '178',
    bankName: '嘉義市第三信用合作社',
  },
  {
    bankCode: '179',
    bankName: '嘉義市第四信用合作社',
  },
  {
    bankCode: '188',
    bankName: '台南第三信用合作社',
  },
  {
    bankCode: '203',
    bankName: '高雄第二信用合作社',
  },
  {
    bankCode: '204',
    bankName: '高雄第三信用合作社',
  },
  {
    bankCode: '215',
    bankName: '花蓮第一信用合作社',
  },
  {
    bankCode: '216',
    bankName: '花蓮第二信用合作社',
  },
  {
    bankCode: '222',
    bankName: '澎湖縣第一信用合作社',
  },
  {
    bankCode: '223',
    bankName: '澎湖縣第二信用合作社',
  },
  {
    bankCode: '224',
    bankName: '金門縣信用合作社',
  },
  {
    bankCode: '700',
    bankName: '中華郵政',
  },
  {
    bankCode: '803',
    bankName: '聯邦商業銀行',
  },
  {
    bankCode: '804',
    bankName: '滙豐銀行(原中華銀行)',
  },
  {
    bankCode: '805',
    bankName: '遠東商業銀行',
  },
  {
    bankCode: '806',
    bankName: '元大銀行',
  },
  {
    bankCode: '807',
    bankName: '永豐銀行',
  },
  {
    bankCode: '808',
    bankName: '玉山商業銀行',
  },
  {
    bankCode: '809',
    bankName: '萬泰商業銀行',
  },
  {
    bankCode: '810',
    bankName: '星辰銀行(原寶華銀行)',
  },
  {
    bankCode: '812',
    bankName: '台新國際商業銀行',
  },
  {
    bankCode: '814',
    bankName: '大眾商業銀行',
  },
  {
    bankCode: '815',
    bankName: '日盛國際商業銀行',
  },
  {
    bankCode: '816',
    bankName: '安泰商業銀行',
  },
  {
    bankCode: '822',
    bankName: '中國信託商業銀行',
  },
  {
    bankCode: '823',
    bankName: '將來銀行',
  },
  {
    bankCode: '825',
    bankName: '慶豐商業銀行',
  },
];
